import React, { FC, Reducer, useReducer } from 'react';
import {LibraryThumbnailPreviewProps, LibraryThumbnailPreviewState, Action, ACTION_TYPE, reducer} from './context';

const initialState: LibraryThumbnailPreviewState = {
  imageBroken: true,
};

const LibraryThumbnailPreview: FC<LibraryThumbnailPreviewProps> = ({
  imageUrl,
}) => {
  const [state, dispatch] = useReducer<Reducer<LibraryThumbnailPreviewState, Action>>(reducer, initialState);

  const onImageError = (error: any) => {
    dispatch({type: ACTION_TYPE.BROKEN, payload: true});
  };

  const onImageLoad = () => {
    dispatch({type: ACTION_TYPE.BROKEN, payload: false});
  };

  const getImageClassName = () => {
    let classNames = 'thumbnail-image-container';
    if (state.imageBroken) {
      classNames += ' thumbnail-image-container-empty';
    }
    return classNames;
  };

  return (
    <div className={getImageClassName()}>
      <img src={imageUrl ?? '/default'} className="thumbnail-image" alt="" onError={onImageError} onLoad={onImageLoad}/>
    </div>
  );
};

LibraryThumbnailPreview.displayName = 'LibraryThumbnailPreview';

export default LibraryThumbnailPreview;
